import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

const LANGS = [
  {
    value: 'tr',
    label: 'Türkçe',
    icon: '/static/icons/ic_flag_tr.svg'
  },
  {
    value: 'en',
    label: 'İngilizce',
    icon: '/static/icons/ic_flag_en.svg'
  } /*
  {
    value: 'de',
    label: 'Almanca',
    icon: '/static/icons/ic_flag_de.svg'
  },
  {
    value: 'fr',
    label: 'Fransızca',
    icon: '/static/icons/ic_flag_fr.svg'
  } */
];

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();
  const langStorage = localStorage.getItem('i18nextLng');
  const currentLang =
    LANGS.find((_lang) => _lang.value === langStorage) || LANGS[0];

  const handleChangeLanguage = (newlang: string) => {
    i18n.changeLanguage(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate,
    currentLang,
    allLang: LANGS
  };
}
